import React, {useState} from "react";
import {useMount} from "ahooks";
import {useLocation, useNavigate} from "react-router-dom";
import StoreOil from "./store_oil";
import OilEngineLinkage, {pickGatherBody} from "./oilenginelinkage/index";
import {Modal, Toast} from "antd-mobile";
import {useDispatch, useSelector} from "react-redux";
import {userAppInfo} from "@store/auth.slice";
import {isCashStatus, gatherConfig, gatherList} from "@api/order";
import * as authStore from "@store/auth.slice";
import * as payStore from "@store/pay.slice";
import {store} from "@store/index";
import Tools from "@utils/tools";
import wx from "weixin-js-sdk-ts";
import {isSubcribeStatus} from "@api/app";
import {CloseCircleOutlined} from "@ant-design/icons";
import '../../components/loading_app.scss';

// 扫码后的模式：loading=探测中 / linkage=油机联动查单 / manual=手动选油品（现状）
type PayMode = 'loading' | 'linkage' | 'manual';

const alert = Modal.alert;

const UserPayApp = () => {
  const userinfo = useSelector(userAppInfo);
  const {user_pay_info} = userinfo;
  const navigate = useNavigate();
  const location = useLocation();
  const disPatch: (...args: unknown[]) => Promise<any> = useDispatch();
  const [is_show, setShowOfficial] = useState(false);
  const [initUrl, setInitUrl] = useState('');
  const [mode, setMode] = useState<PayMode>('loading');

  useMount(()=> {
    checkTime();
    // 初始化
    initPage().then(()=> {
      console.log('初始化支付...')
      // 拉完门店信息后探测零管模式，决定走"查单"还是"手动"
      return probeMode();
    })
  })

  // 探测零管/查单模式（照小程序 get_zero_status + probeStationMode）：
  // 零管开关开 且 探测非 MANUAL_MODE → 走查单（linkage）；否则回退手动（manual，即现状）。
  const probeMode = async ()=> {
    try {
      const info = userinfoRef();
      const room_id = info?.room_id;
      if (!room_id) return setMode('manual');
      const cfg = await gatherConfig({room_id});
      if (cfg?.code !== 200 || !cfg?.data?.is_open) return setMode('manual');
      const cateId = info?.cate?.[0]?.list?.[0]?.id;
      if (!cateId) return setMode('manual');
      const res = await gatherList({room_id, cate_id: cateId});
      const body = pickGatherBody(res);
      if (body && body.code === 'MANUAL_MODE') return setMode('manual');
      return setMode('linkage');
    } catch (e) {
      console.log(e);
      // 探测失败一律回退手动，保证不回归
      setMode('manual');
    }
  }

  // 读取最新门店信息：setUserPayCon 已写入 redux，这里直接从 store 取（避免闭包旧值）
  const userinfoRef = ()=> {
    return store.getState().auth.user_pay_info;
  }

  // 重新检测时间日期
  const checkTime = ()=> {
    const urlParam = Tools.param2Obj();
    if (urlParam.hasOwnProperty('time')) {
      const currentTime = new Date().getTime() / 1000; // 当前时间（秒）
      const createTime = Number(urlParam.time); // 链接生成时间（秒，需确保后端传秒级）
      const diffMinutes = (currentTime - createTime) / 60; // 已过分钟数
      if (diffMinutes > 5) {
        Modal.alert('温馨提示', '此链接已过期，请重新扫码获取!', [{
          text: '我知道了',
          onPress: ()=> wx.closeWindow()
        }])
      }
    }
  }

  const initPage = ()=> {
    Toast.loading('请稍候...')
    return Promise.all([
      setUserPayInfo(),
      cash_order_status(),
      isOfficialImg(),
      disPatch(payStore.setInitMoney()),
    ]).then(()=> {
      Toast.hide();
    })
  }

  const setUserPayInfo = () => {
    // 必须 return，让 initPage 的 Promise.all 等门店信息就绪后再 probeMode
    return disPatch(authStore.setUserPayCon(location.search));
  }

  const isOfficialImg = async ()=> {
    try {
      const urlParam = Tools.param2Obj();
      if (!urlParam.hasOwnProperty('qrcode_id')) return;
      const res = await isSubcribeStatus(urlParam.qrcode_id, urlParam.app_token);
      if (res.code === 200) {
        if (res.data.subscribe === 0) {
          setInitUrl(res.data.url);
          setShowOfficial(true);
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const cash_order_status = async()=> {
    const res = await isCashStatus();
    if (res.code === 200) {
      if (res.data.data) {
        alert('确认订单', '您有未确认订单，请联系加油员进行确认!', [
          { text: '我知道了', onPress: () => {
              navigate(`/viphome`, {replace: true})
            }
          }
        ])
      }
    }
  }

  // 模式分流渲染：查单 → OilEngineLinkage；手动/探测失败 → 现有 StoreOil
  const ModeView = ()=> {
    if (mode === 'loading') {
      return <div style={{padding: '80px 0', textAlign: 'center', color: '#999', fontSize: '14px'}}>加载中...</div>;
    }
    if (mode === 'linkage') {
      return <OilEngineLinkage userInfo={user_pay_info} onSwitchManual={()=> setMode('manual')} />;
    }
    return <StoreOil userInfo={user_pay_info} />;
  }

  return (
    <>
      <ModeView />
      <div className={'mask-box'} style={is_show ? {display: 'block'}:{display: 'none'}}>
        <img src={initUrl} alt={'关注公众号'}/>
        <div className={'close-icon-all'}>
          <CloseCircleOutlined onClick={()=> setShowOfficial(false)} />
        </div>
      </div>
    </>
  )
}

export default UserPayApp;